import * as types from './types';
import { actionTypes as resourceActions } from 'redux-resource';

const DEFAULT_ERROR_MESSAGE = 'Server Error';

export const find = (id) => ({
  type: types.FIND,
  payload: { id },
});

export const fetchFiltered = (params) => ({
  type: types.FETCH_FILTERED,
  payload: { params },
});

/*
 *  Create
 */
export const create = (attrs) => ({
  type: types.CREATE,
  payload: { attrs },
});
const createDefaults = {
  resourceType: 'insuredDevices',
  requestKey: 'create',
}
export const createPending = () => ({
  ...createDefaults,
  type: resourceActions.CREATE_RESOURCES_PENDING,
});
export const createSucceeded = (response) => ({
  ...createDefaults,
  type: resourceActions.CREATE_RESOURCES_SUCCEEDED,
  resources: [response.data],
});
export const createFailed = (err) => ({
  ...createDefaults,
  type: resourceActions.CREATE_RESOURCES_FAILED,
  requestProperties: {
    error: err.response.data
      ? err.response.data.message || "Server error: can't create insured device"
      : "Server error: can't create insured device", 
  } 
});

/**
 * Cancel
 */

export const cancel = (id, params) => ({
  type: types.CANCEL,
  payload: { id, params }
});


/**
 * Activate
 */
export const activate = (id) => ({
  type: types.ACTIVATE,
  payload: { id }
});

const activateDefaults = {
  requestKey: 'activate',
}
export const activatePending = (resourceType, actionProps) => ({
  ...activateDefaults,
  ...actionProps,
  resourceType,
  type: resourceActions.UPDATE_RESOURCES_PENDING,
});
export const activateSucceeded = (resourceType, response, transformResp = (resp) => { return [resp.data] }, actionProps) => ({
  ...activateDefaults,
  ...actionProps,
  resourceType,
  type: resourceActions.UPDATE_RESOURCES_SUCCEEDED,
  resources: transformResp(response),
  requestProperties: {
    error: '',
  },
});
export const activateFailed = (resourceType, err, actionProps) => ({
  ...activateDefaults,
  ...actionProps,
  resourceType,
  type: resourceActions.UPDATE_RESOURCES_FAILED,
  requestProperties: {
    error: err.response && err.response.data
      ? err.response.data.message || DEFAULT_ERROR_MESSAGE
      : DEFAULT_ERROR_MESSAGE, 
  },
});

export const setPurchase = (id, purchase) => ({
  type: resourceActions.UPDATE_RESOURCES,
  meta: {
    insuredDevices: {
      [id]: { purchase }
    }
  }
});

